import { render, staticRenderFns } from "./sfc-plan-card.vue?vue&type=template&id=58fd4243&scoped=true&lang=pug&"
import script from "./sfc-plan-card.vue?vue&type=script&lang=js&"
export * from "./sfc-plan-card.vue?vue&type=script&lang=js&"
import style0 from "./sfc-plan-card.vue?vue&type=style&index=0&id=58fd4243&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fd4243",
  null
  
)

export default component.exports